@if (isEnrollmentsLoading()) {
	<lb-loader></lb-loader>
} @else {
	<lb-two-column-page-layout>
		<ng-container two-column-page-layout-left-content>
			<div class="section-header">
				<div class="section-label">My Learning</div>
				<div class="enrollment-pagers">
					<div class="container">
						<button md-button [disabled]="isFirstEnrollment()" (click)="goToPreviousEnrollment()">
							<md-icon icon="untitled-ui/arrows/chevron-left"></md-icon>
						</button>
						<button md-button [disabled]="isLastEnrollment()" (click)="goToNextEnrollment()">
							<md-icon icon="untitled-ui/arrows/chevron-right"></md-icon>
						</button>
					</div>
				</div>
			</div>
			<div class="section-content enrollments-list">
				@if (enrollmentDetail(); as detail) {
					@if (isAwaitingSchedule()) {
						<lrnr-enrollment-info-panel [currentEnrollment]="detail"></lrnr-enrollment-info-panel>
					} @else if (usesV2(detail)) {
						<lrnr-enrollment-card [enrollment]="detail"></lrnr-enrollment-card>
					} @else {
						<lb-enrollment-card [enrollment]="detail" userView="instructor"></lb-enrollment-card>
					}
				} @else {
					<span>No active enrollments found.</span>
				}
			</div>
			<div class="section-header">
				<div class="section-label">Upcoming Lessons</div>
				<div class="view-toggle">
					<a routerLink="/lessons" md-button>View All</a>
				</div>
			</div>

			<div class="section-content">
				@if (lessons().length > 0) {
					<div class="lesson-view">
						<div class="main-content">
							<div class="lesson-list">
								@for (lesson of lessons().slice(0, 3); track $index) {
									@if (usesV2(lesson)) {
										<lrnr-lesson-card [lesson]="lesson"></lrnr-lesson-card>
									} @else {
										<lb-readonly-lesson-card [lesson]="lesson"></lb-readonly-lesson-card>
									}
								}
							</div>
						</div>
					</div>
				} @else {
					<lb-no-data-message iconUrl="untitled-ui/education/book-open-01">
						<div>Your lessons are waiting! Complete your schedule to get started.</div>
					</lb-no-data-message>
				}
			</div>
		</ng-container>
		<ng-container two-column-page-layout-right-content>
			<div class="sidebar">
				@if (isAwaitingSchedule()) {
					<div class="orientation">
						<span class="md-text-lg-semibold">Begin your orientation journey here!</span>

						<a routerLink="/orientation" md-button-brand class="larger-button">Launch Learner Orientation</a>
					</div>
				}
				<lb-notifications></lb-notifications>

				<lb-need-help-card></lb-need-help-card>
			</div>
		</ng-container>
	</lb-two-column-page-layout>
}
